import { Close } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import useEventHandler from "./hooks/useEventHandler";
import { STYLES } from "./style/customStyles";

export default function SingleLineTextField({
  placeholder,
  fieldName,
  fieldValue,
  customOnChange,
  noClearIcon = false,
}) {
  const { localValue, handleOnInputChange, handleOnClearInput } = useEventHandler(
    fieldValue,
    customOnChange
  );

  return (
    <div className="flex-1">
      <TextField
        id="single-line-text-field"
        placeholder={placeholder}
        className="w-full"
        variant="outlined"
        value={localValue}
        onChange={(e) => handleOnInputChange(e, customOnChange, fieldName)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment:
            localValue && !noClearIcon ? (
              <InputAdornment position="end" className="p-4">
                <IconButton onClick={() => handleOnClearInput(fieldName)} edge="end" size="small">
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
        }}
        sx={STYLES.textField}
        size="small"
      />
    </div>
  );
}
